import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  ActiveCartService,
  CmsAddToCartComponent,
  EventService,
  GlobalMessageService,
  GlobalMessageType,
  isNotNullable,
  Product,
  TranslationService,
} from '@spartacus/core';
import {
  AddToCartComponent,
  CmsComponentData,
  CurrentProductService,
  ModalService,
  ProductListItemContext,
} from '@spartacus/storefront';
import { filter } from 'rxjs/operators';
import { EkAddedToCartDialogComponent } from '../ek-added-to-cart-dialog/ek-added-to-cart-dialog.component';

@Component({
  selector: 'app-add-to-ekcart',
  templateUrl: './add-to-ekcart.component.html',
  styleUrls: ['./add-to-ekcart.component.scss'],
})
export class AddToEkcartComponent
  extends AddToCartComponent
  implements OnInit, OnDestroy
{
  @Input() productCode: string | any;
  @Input() showQuantity: boolean = true;
  maxQuantity: number = 999;
  addToCartForm = new FormGroup({
    quantity: new FormControl(1, { updateOn: 'blur' }),
  });
  addedToCart: string | any;
  constructor(
    public modalService: ModalService,
    public currentProductService: CurrentProductService,
    public cd: ChangeDetectorRef,
    public activeCartService: ActiveCartService,
    public component: CmsComponentData<CmsAddToCartComponent>,
    public eventService: EventService,
    public globalMessageService: GlobalMessageService,
    public translationService: TranslationService,
    @Optional() protected productListItemContext?: ProductListItemContext
  ) {
    super(modalService, currentProductService, cd, activeCartService);
  }

   /**
   * Provides required data and opens AddedToCartDialogComponent modal
   */
  public openModal() {
    let modalInstance: any;
    this.modalRef = this.modalService.open(EkAddedToCartDialogComponent, {
      centered: true,
      size: 'lg',
    });

    modalInstance = this.modalRef.componentInstance;
    // Display last entry for new product code. This always corresponds to
    // our new item, independently of whether merging occured or not
    modalInstance.entry$ = this.activeCartService.getLastEntry(
      this.productCode
    );
    modalInstance.cart$ = this.activeCartService.getActive();
    modalInstance.loaded$ = this.activeCartService.isStable();
    modalInstance.quantity = this.quantity;
    modalInstance.numberOfEntriesBeforeAdd = this.numberOfEntriesBeforeAdd;
  }

  ngOnInit(): void {
    this.translationService
      .translate('productcardinformation.addedtocart')
      .subscribe((data) => {
        if (data) {
          this.addedToCart = data;
        }
        this.cd.detectChanges();
      });
    this.maxQuantity = 999;
    if (this.product) {
      this.productCode = this.product.code ?? '';
      this.setStockInfo(this.product);
      this.cd.markForCheck();
    } else if (this.productCode) {
      // force hasStock and quantity for the time being, as we do not have more info:
      this.quantity = 1;
      this.hasStock = true;
      this.cd.markForCheck();
    } else {
      this.subscription = (
        this.productListItemContext
          ? this.productListItemContext.product$
          : this.currentProductService.getProduct()
      )
        .pipe(filter(isNotNullable))
        .subscribe((product) => {
          this.productCode = product.code ?? '';
          this.setStockInfo(product);
          this.cd.markForCheck();
        });
    }
  }

  public setStockInfo(product: Product): void {
    this.quantity = 1;
    this.hasStock = Boolean(product.stock?.stockLevelStatus !== 'outOfStock');

    this.inventoryThreshold = product.stock?.isValueRounded ?? false;

    if (this.hasStock && product.stock?.stockLevel) {
      this.maxQuantity = product.stock.stockLevel;
    }

    if (this.productListItemContext) {
      this.showQuantity = false;
    }
  }

  successMsg() {
    this.globalMessageService.add(
      this.addedToCart ?? '',
      GlobalMessageType.MSG_TYPE_CONFIRMATION,
      60
    );
  }

  updateCount(value: number): void {
    this.quantity = value;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_CONFIRMATION);
  }
}
